import { UseCountriesByOriginIdProps } from './props';
import { useUserOriginId } from '../../user-identity/useUserOriginId';
import { useCountries } from '../../../api/countries/queries';
import { Nullable } from '@starsoft/common/interfaces';

/**
 * Custom hook to fetch countries based on the user's origin ID.
 * This hook retrieves the user's origin ID and fetches the countries accordingly.
 *
 * @param {UseCountriesByOriginIdProps} [options] - Options to customize the query and filtering.
 * @param {string} [options.query] - Query string to filter the countries.
 * @param {boolean} [options.filterByOrigin=false] - Whether to filter countries by the user's origin ID.
 * @returns {Object} An object containing the fetched countries.
 *
 * @example
 * // Usage example:
 * const { countries } = useCountriesByOriginId({ query: 'Europe', filterByOrigin: true });
 */
export function useCountriesByOriginId(options?: UseCountriesByOriginIdProps) {
  const { query, filterByOrigin = false } = options ?? {};
  const originId: Nullable<string> = useUserOriginId();

  return useCountries({
    originId: filterByOrigin ? originId : undefined,
    query: query ?? undefined,
  });
}

export type { UseCountriesByOriginIdProps };
